import styled from 'styled-components';
import Clickable from '@prisjakt/ui-clickable';
import { BodySmallText, H3Text } from '@prisjakt/ui/text/variants';
import { layout, media } from '@prisjakt/ui-base';
import { PrimaryButton } from '@prisjakt/ui/button/variants';

export const StyledContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  border-radius: 8px;

  > :not(:last-child) {
    margin-right: ${layout.measurements.spacing100};
  }

  ${media.smallOnly`
    justify-content: center;
  `}
`;

export const StyledContent = styled.div`
  display: grid;
  grid-row-gap: ${layout.measurements.spacing050};
  height: fit-content;
`;

const ILLUSTRATION_MAX_HEIGHT = 100;

export const StyledIllustration = styled.img`
  max-height: ${ILLUSTRATION_MAX_HEIGHT}px;
  width: auto;
  height: auto;
`;

export const StyledLink = styled(Clickable)`
  margin: ${layout.measurements.spacing050} 0;
  text-decoration: underline;
`;

export const StyledCategoryText = styled(BodySmallText)`
  margin-right: ${layout.measurements.spacing025};
`;

export const StyledAlertButton = styled(PrimaryButton)`
  ${media.smallOnly`
    width: 100%;
  `}
`;

export const StyledTitle = styled(H3Text)`
  margin: 0;
`;
